import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'cigna-cfb-back-and-close-button',
  templateUrl: './back-and-close-button.component.html',
  styleUrls: ['./back-and-close-button.component.scss'],
})
export class BackCloseButtonComponent implements OnInit {
  @Input() isBackBtnEnabled = true;
  @Input() isCloseBtnEnabled = true;
  @Input() renderMode: string;
  @Input() lob: string;

  @Output() backButtonClickCommercial = new EventEmitter();
  @Output() backButtonClickIfp = new EventEmitter();
  @Output() backButtonClickMa = new EventEmitter();
  @Output() backButtonClickCsb = new EventEmitter();
  @Output() backButtonClickRestart = new EventEmitter();
  @Output() backButtonClick = new EventEmitter();
  @Output() closeButtonClick = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  backButtonEvent() {
    if (this.lob === 'COMMERCIAL') {
      this.backButtonClickCommercial.emit();
    } else if (this.lob === 'IFP') {
      this.backButtonClickIfp.emit();
    } else if (this.lob === 'MA') {
      this.backButtonClickMa.emit();
    } else if (this.lob === 'CSB') {
      this.backButtonClickCsb.emit();
    } else if (this.lob === 'RESTART') {
      this.backButtonClickRestart.emit();
    }

    if (!this.lob) {
      this.backButtonClick.emit();
    }
  }

  closeButtonEvent() {
    this.closeButtonClick.emit();
  }
}
